import styled from "styled-components/macro";

export const Container = styled.div`
   display: flex;
   flex-direction: column;
   border-bottom: 8px solid solid #222;
   text-align: center;
   padding: 165px 45px;
`;

export const Title = styled.h1`
color: white;
max-width: 640px;
font-family:"Netflix Sans", "Helvetica Neue", Helvetica, Arial, sans-serif
line-height: 55px;
text-align: center;
text-size-adjust: 100%;
direction: ltr;
font-size: 60px;
font-weight: 700;
margin: auto;

@media (max-width: 600px){
   font-size: 35px;
   
}
`;

export const SubTitle = styled.h2`
   color: white;
   font-family:"Netflix Sans", "Helvetica Neue", Helvetica, Arial, sans-serif
   
   font-size: 26px;
   font-weight: 400;
   margin: 16px auto;
   text-size-adjust: 100%;
   @media (max-width: 600px) {
      font-size: 18px;
   }
   `;